import { Controller } from "@hotwired/stimulus"

// Прогрессивное улучшение формы расхода: скрывает поле "новая позиция"
// и показывает его по клику на ссылку/чекбокс "Добавить новую позицию".
// Без JS поле остаётся видимым (fallback), т.к. класс d-none навешивается только здесь.
export default class extends Controller {
  static targets = ["field", "input", "select", "toggle"]

  connect() {
    this.hide()
  }

  toggle(event) {
    event.preventDefault()
    if (this.fieldTarget.classList.contains("d-none")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.fieldTarget.classList.remove("d-none")
    if (this.hasSelectTarget) {
      this.selectTarget.disabled = true
    }
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "true")
    }
  }

  hide() {
    this.fieldTarget.classList.add("d-none")
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
    if (this.hasSelectTarget) {
      this.selectTarget.disabled = false
    }
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
    }
  }
}
